import { Component, Input, OnInit } from '@angular/core';

// Modelos de los datos
interface IPacientes {
  Nuevos: number;
  Prevalentes: number;
  Muertes: number;
}

interface ICostos {
  Nuevos: number;
  Prevalentes: number;
  Total: number;
}

interface IDetallesPorGenero {
  masculino: {
    Sexo: string;
    pacientes: IPacientes;
    costos: ICostos;
    costos_parciales: number;
    referencias?: any[];
  };
  femenino: {
    Sexo: string;
    pacientes: IPacientes;
    costos: ICostos;
    costos_parciales: number;
    referencias?: any[];
  };
  ambos: {
    referencias?: any[];
  };
}

interface ICargaEconomica {
  [enfermedad: string]: {
    Detalles_por_genero: IDetallesPorGenero;
    Total_costos: number;
  };
}

@Component({
  selector: 'app-obesity-economic-burden',
  templateUrl: './obesity-illness-cost.component.html',
  styleUrls: ['./obesity-illness-cost.component.css']
})
export class ObesityIllnessCostComponent implements OnInit {

  @Input() codigo: string;
  cargaEconomicaData: ICargaEconomica = {}; // Aquí almacenamos los datos de la carga económica
  active: string = ''; // Se inicializa correctamente la propiedad `active` con un valor vacío
  totalCostos: number = 0; // Variable para el total de todos los costos
  private intervalId: any; // Para guardar el ID del setInterval


  constructor() {}

  ngOnInit(): void {
    this.loadCargaEconomicaFromLocalStorage();

    this.intervalId = setInterval(() => {
      this.loadCargaEconomicaFromLocalStorage();
    }, 1000); // 1000 ms = 1 segundo
  }

  ngOnDestroy(): void {
    // Limpiar el intervalo cuando el componente se destruya para evitar fugas de memoria
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  // Método para cargar los datos desde localStorage
  loadCargaEconomicaFromLocalStorage(): void {
    const storedData = localStorage.getItem('valor_por_defecto');

    if (storedData) {
      try {
        this.cargaEconomicaData = JSON.parse(storedData);
        const firstKey = Object.keys(this.cargaEconomicaData)[0];
        this.active = firstKey;  // Asignar la primera enfermedad a `active`
        this.calculateTotalCostos();  // Calcular el total de todos los costos
      } catch (error) {
        console.error('Error al parsear los datos desde localStorage', error);
      }
    } else {
      console.warn('No se encontraron datos en localStorage bajo la clave "valor_por_defecto"');
    }
  }

  

  // Método para obtener los costos totales
  getTotalCostos(enfermedad: string): number {
    const data = this.cargaEconomicaData[enfermedad];
    if (data) {
      return data.Total_costos || 0;
    }
    return 0;
  }

  // Método que calcula el total de todos los costos
  calculateTotalCostos(): void {
    this.totalCostos = Object.values(this.cargaEconomicaData).reduce((acc, curr) => {
      return acc + (curr.Total_costos || 0);
    }, 0);
  }

  // Método que valida si una enfermedad tiene referencias
  hasReferences(referencias: any[]): boolean {
    return referencias && referencias.length > 0;
  }

  // Método para obtener el primer número de referencia (si existe)
  getFirstReferenceNumber(referencias: any[]): number | null {
    if (this.hasReferences(referencias)) {
      return referencias[0].number;
    }
    return null;
  }
}
